import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonTypeEnum} from '../../enums/skeleton';

export const RowSkeleton: ISkeleton[] = [
  {
    multiple: false,
    type: SkeletonTypeEnum.INPUT,
    style: 'width: 100%; height: 45px;',
    classes: 'mb-md',
  },
];
